"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombiPdReasonForTestingDtoToJSON = exports.CombiPdReasonForTestingDtoFromJSONTyped = exports.CombiPdReasonForTestingDtoFromJSON = exports.instanceOfCombiPdReasonForTestingDto = exports.CombiPdReasonForTestingDtoPregnancyTerminatedEnum = exports.CombiPdReasonForTestingDtoPgtaResultsEnum = exports.CombiPdReasonForTestingDtoNipsLabEnum = exports.CombiPdReasonForTestingDtoFetalKaryotypeEnum = exports.CombiPdReasonForTestingDtoFetalSexEnum = exports.CombiPdReasonForTestingDtoPregnancyTypeEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.CombiPdReasonForTestingDtoPregnancyTypeEnum = {
    Singleton: 'Singleton',
    Twins: 'Twins',
    Triplets: 'Triplets'
};
/**
 * @export
 */
exports.CombiPdReasonForTestingDtoFetalSexEnum = {
    Unknown: 'Unknown',
    Female: 'Female',
    Male: 'Male',
    Ambiguous: 'Ambiguous'
};
/**
 * @export
 */
exports.CombiPdReasonForTestingDtoFetalKaryotypeEnum = {
    Pending: 'Pending',
    _46Xx: '46,XX',
    _46Xy: '46,XY',
    Abnormal: 'Abnormal'
};
/**
 * @export
 */
exports.CombiPdReasonForTestingDtoNipsLabEnum = {
    InvitaeInvitaeNips: 'Invitae - Invitae NIPS',
    AveroPrenatalScreen: 'AVERO - Prenatal Screen',
    CounsylMyriadPrelude: 'Counsyl/Myriad - Prelude',
    IllumniaVerifi: 'Illumnia - Verifi',
    IlluminaVerifi: 'Illumina - Verifi',
    IntegratedGeneticsInformaSeq: 'Integrated Genetics - InformaSeq',
    NateraVistara: 'Natera - Vistara',
    NateraPanorama: 'Natera - Panorama',
    OpkoClaritest: 'OPKO - Claritest',
    ProgenityInnatal: 'Progenity - Innatal',
    ProgenityResura: 'Progenity - Resura',
    QuestQNatal: 'Quest - QNatal',
    RocheHarmony: 'Roche - Harmony',
    SequenomMaterniTGenome: 'Sequenom - MaterniT Genome',
    SequenomMaterniT21Plus: 'Sequenom - MaterniT21 PLUS',
    NxGenMdxNipt: 'NxGenMDx - NIPT',
    Other: 'Other'
};
/**
 * @export
 */
exports.CombiPdReasonForTestingDtoPgtaResultsEnum = {
    Abnormal: 'Abnormal',
    Normal: 'Normal'
};
/**
 * @export
 */
exports.CombiPdReasonForTestingDtoPregnancyTerminatedEnum = {
    SabIufd: 'SAB/IUFD',
    Tab: 'TAB'
};
/**
 * Check if a given object implements the CombiPdReasonForTestingDto interface.
 */
function instanceOfCombiPdReasonForTestingDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCombiPdReasonForTestingDto = instanceOfCombiPdReasonForTestingDto;
function CombiPdReasonForTestingDtoFromJSON(json) {
    return CombiPdReasonForTestingDtoFromJSONTyped(json, false);
}
exports.CombiPdReasonForTestingDtoFromJSON = CombiPdReasonForTestingDtoFromJSON;
function CombiPdReasonForTestingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isAdvancedMaternalAge': !(0, runtime_1.exists)(json, 'isAdvancedMaternalAge') ? undefined : json['isAdvancedMaternalAge'],
        'isPositiveSerumScreen': !(0, runtime_1.exists)(json, 'isPositiveSerumScreen') ? undefined : json['isPositiveSerumScreen'],
        'isAbnormalUltrasound': !(0, runtime_1.exists)(json, 'isAbnormalUltrasound') ? undefined : json['isAbnormalUltrasound'],
        'isHistorySuggestsRisk': !(0, runtime_1.exists)(json, 'isHistorySuggestsRisk') ? undefined : json['isHistorySuggestsRisk'],
        'isOtherIndicationReason': !(0, runtime_1.exists)(json, 'isOtherIndicationReason') ? undefined : json['isOtherIndicationReason'],
        'gravida': !(0, runtime_1.exists)(json, 'gravida') ? undefined : json['gravida'],
        'para': !(0, runtime_1.exists)(json, 'para') ? undefined : json['para'],
        'sabs': !(0, runtime_1.exists)(json, 'sabs') ? undefined : json['sabs'],
        'tabs': !(0, runtime_1.exists)(json, 'tabs') ? undefined : json['tabs'],
        'maternalHeightCentimeters': !(0, runtime_1.exists)(json, 'maternalHeightCentimeters') ? undefined : json['maternalHeightCentimeters'],
        'maternalWeightGrams': !(0, runtime_1.exists)(json, 'maternalWeightGrams') ? undefined : json['maternalWeightGrams'],
        'estimatedDueDate': !(0, runtime_1.exists)(json, 'estimatedDueDate') ? undefined : json['estimatedDueDate'],
        'pregnancyType': !(0, runtime_1.exists)(json, 'pregnancyType') ? undefined : json['pregnancyType'],
        'fetalSex': !(0, runtime_1.exists)(json, 'fetalSex') ? undefined : json['fetalSex'],
        'fetalKaryotype': !(0, runtime_1.exists)(json, 'fetalKaryotype') ? undefined : json['fetalKaryotype'],
        'gestationalAgeDays': !(0, runtime_1.exists)(json, 'gestationalAgeDays') ? undefined : json['gestationalAgeDays'],
        'gestationalAgeWeeks': !(0, runtime_1.exists)(json, 'gestationalAgeWeeks') ? undefined : json['gestationalAgeWeeks'],
        'nipsResults': !(0, runtime_1.exists)(json, 'nipsResults') ? undefined : json['nipsResults'],
        'nipsLab': !(0, runtime_1.exists)(json, 'nipsLab') ? undefined : json['nipsLab'],
        'isVanishingTwin': !(0, runtime_1.exists)(json, 'isVanishingTwin') ? undefined : json['isVanishingTwin'],
        'isIvf': !(0, runtime_1.exists)(json, 'isIvf') ? undefined : json['isIvf'],
        'isEggDonor': !(0, runtime_1.exists)(json, 'isEggDonor') ? undefined : json['isEggDonor'],
        'eggDonorAge': !(0, runtime_1.exists)(json, 'eggDonorAge') ? undefined : json['eggDonorAge'],
        'pgtaResults': !(0, runtime_1.exists)(json, 'pgtaResults') ? undefined : json['pgtaResults'],
        'isGestationalCarrier': !(0, runtime_1.exists)(json, 'isGestationalCarrier') ? undefined : json['isGestationalCarrier'],
        'isSpermDonor': !(0, runtime_1.exists)(json, 'isSpermDonor') ? undefined : json['isSpermDonor'],
        'pregnancyTerminated': !(0, runtime_1.exists)(json, 'pregnancyTerminated') ? undefined : json['pregnancyTerminated'],
        'additionalInfo': !(0, runtime_1.exists)(json, 'additionalInfo') ? undefined : json['additionalInfo'],
        'additionalClinHistory': !(0, runtime_1.exists)(json, 'additionalClinHistory') ? undefined : json['additionalClinHistory'],
        'wasNipsPerformed': !(0, runtime_1.exists)(json, 'wasNipsPerformed') ? undefined : json['wasNipsPerformed'],
        'otherIndicationReason': !(0, runtime_1.exists)(json, 'otherIndicationReason') ? undefined : json['otherIndicationReason'],
    };
}
exports.CombiPdReasonForTestingDtoFromJSONTyped = CombiPdReasonForTestingDtoFromJSONTyped;
function CombiPdReasonForTestingDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isAdvancedMaternalAge': value.isAdvancedMaternalAge,
        'isPositiveSerumScreen': value.isPositiveSerumScreen,
        'isAbnormalUltrasound': value.isAbnormalUltrasound,
        'isHistorySuggestsRisk': value.isHistorySuggestsRisk,
        'isOtherIndicationReason': value.isOtherIndicationReason,
        'gravida': value.gravida,
        'para': value.para,
        'sabs': value.sabs,
        'tabs': value.tabs,
        'maternalHeightCentimeters': value.maternalHeightCentimeters,
        'maternalWeightGrams': value.maternalWeightGrams,
        'estimatedDueDate': value.estimatedDueDate,
        'pregnancyType': value.pregnancyType,
        'fetalSex': value.fetalSex,
        'fetalKaryotype': value.fetalKaryotype,
        'gestationalAgeDays': value.gestationalAgeDays,
        'gestationalAgeWeeks': value.gestationalAgeWeeks,
        'nipsResults': value.nipsResults,
        'nipsLab': value.nipsLab,
        'isVanishingTwin': value.isVanishingTwin,
        'isIvf': value.isIvf,
        'isEggDonor': value.isEggDonor,
        'eggDonorAge': value.eggDonorAge,
        'pgtaResults': value.pgtaResults,
        'isGestationalCarrier': value.isGestationalCarrier,
        'isSpermDonor': value.isSpermDonor,
        'pregnancyTerminated': value.pregnancyTerminated,
        'additionalInfo': value.additionalInfo,
        'additionalClinHistory': value.additionalClinHistory,
        'wasNipsPerformed': value.wasNipsPerformed,
        'otherIndicationReason': value.otherIndicationReason,
    };
}
exports.CombiPdReasonForTestingDtoToJSON = CombiPdReasonForTestingDtoToJSON;
